import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ButtonFill from "../../components/button/ButtonFill";
import ButtonOutline from "../../components/button/ButtonOutline";
import { addPlaylist } from "../../redux/actions/music";

const CreatePlaylist = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { playlist } = useSelector((state) => state.music);
  const [value, setvalue] = useState("");
  const [focused, setfocused] = useState(false);
  const valueLimit = 20;

  return (
    <div className="create-playlist">
      <div className="container">
        <h1>Create Playlist</h1>
        <div className={`input ${focused ? "focused" : ""}`}>
          <input
            type="text"
            placeholder="Enter your playlist name"
            value={value}
            onChange={(e) => e.target.value.length <= valueLimit && setvalue(e.target.value.replace(/[^\w\s]/gi, ""))}
            onFocus={() => setfocused(true)}
            onBlur={() => setfocused(false)}
          />
        </div>
        <div className="char">
          {value.length}/{valueLimit}
        </div>
        <div className="actions">
          {/* <div className="cancel" onClick={() => navigate(-1)}>
            Cancel
          </div> */}
          <div
            className="create"
            onClick={() => dispatch(addPlaylist(value ? value : `Playlist ${playlist.length + 1}`, navigate))}
          >
            Create
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreatePlaylist;
